/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { baseDataResponse } from '../models/baseDataResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BaseDataService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * retrieves base data
   * Returns base data which can be used in search operations as query parameters <table border>
   * <tr>
   * <th> Name</th>
   * <th> Funktion</th>
   * </tr>
   * <tr>
   * <td> processInfo - success</td>
   * <td> Erfolgreiche Verarbeitung der Anfrage</td>
   * </tr>
   * <tr>
   * <td> processInfo - time</td>
   * <td> Antwortzeit der Response in ms</td>
   * </tr>
   * <tr>
   * <td> processInfo - requestId</td>
   * <td> Zeitstempel der Anfrage</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - messageType</td>
   * <td> Art der Nachricht (Error, ConfigurationError, Information)</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - processIdentifier</td>
   * <td> Identifikator des Verarbeitungsservices</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - messageCode</td>
   * <td> Nachrichtencode</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - message</td>
   * <td> Nachricht</td>
   * </tr>
   * <tr>
   * <td> lang</td>
   * <td> Zwei-Letter Sprachcode nach ISO-639-1</td>
   * </tr>
   * <tr>
   * <td> currency</td>
   * <td> Drei-Letter-Währungscode nach ISO-4217</td>
   * </tr>
   * <tr>
   * <td> cruise - shipCodes</td>
   * <td> Eindeutige Buchungscodes der Schiffe</td>
   * </tr>
   * <tr>
   * <td> cruise - ports - code</td>
   * <td> Eindeutiger Code des Hafens</td>
   * </tr>
   * <tr>
   * <td> cruise - ports - isDeparturePort</td>
   * <td> Gibt an ob der Hafen der Start-Hafen einer Reise ist</td>
   * </tr>
   * <tr>
   * <td> cruise - ports - isArrivalPort</td>
   * <td> Gibt an ob der Hafen der End-Hafen einer Reise ist</td>
   * </tr>
   * <tr>
   * <td> cruise - cabinTypes</td>
   * <td> Liste der verfügbaren (eindeutigen) Kabinen-Typ-Codes</td>
   * </tr>
   * <tr>
   * <td> cruise - tariffTypes </td>
   * <td> List der verfügbaren (eindeutigen) Tarif-Codes </td>
   * </tr>
   * <tr>
   * <td> cruise - passengers - maxAdults</td>
   * <td> Maximal wählbare Anzahl von Erwachsenen (siehe /cruiseList - passenger.adults)</td>
   * </tr>
   * <tr>
   * <td> cruise - passengers - minAdults</td>
   * <td> Minimal wählbare Anzahl von Erwachsenen (siehe /cruiseList - passenger.adults)</td>
   * </tr>
   * <tr>
   * <td> cruise - passengers - maxChildren</td>
   * <td> Maximal wählbare Anzahl von Kindern (siehe /cruiseList - passenger.children)</td>
   * </tr>
   * <tr>
   * <td> cruise - passengers - minChildren</td>
   * <td> Minimal wählbare Anzahl von Kindern (siehe /cruiseList - passenger.children)</td>
   * </tr>
   * <tr>
   * <td> cruise - duration - code</td>
   * <td> Eindeutiger Reisedauer-Code</td>
   * </tr>
   * <tr>
   * <td> cruise - duration - name</td>
   * <td> Marketing-Name der Reisedauer</td>
   * </tr>
   * <tr>
   * <td> cruise - dateRange</td>
   * <td> Maximal auswählbarer Zeitraum in Tagen (siehe /cruiseList - period.start.date, period.end.date) </td>
   * </tr>
   * <tr>
   * <td> flight - departureAirports</td>
   * <td> Liste der IATA-Codes verfügbarer Start-Flughäfen</td>
   * </tr>
   * <tr>
   * <td> flight - arrivalAirports</td>
   * <td> Liste der IATA-Codes verfügbarer Ziel-Flughäfen</td>
   * </tr>
   * <tr>
   * <td> geoLocations - regions</td>
   * <td> Liste aller verfügbaren (eindeutigen) Regions-Codes</td>
   * </tr>
   * <tr>
   * <td> priceTypes</td>
   * <td> Liste aller verfügbaren (eindeutigen) Preis-Typ-Codes</td>
   * </tr>
   * <tr>
   * <td> periods - firstCheckInDate</td>
   * <td> Startdatum der frühsten (verfügbaren) Reise </td>
   * </tr>
   * <tr>
   * <td> periods - lastCheckOutDate</td>
   * <td> Enddatum der spätesten (verfügbaren) Reise </td>
   * </tr>
   * </table>
   *
   * @returns baseDataResponse general, cruise and or flight base data, ports, regions, ship codes, airports, price type, ...
   * @throws ApiError
   */
  public getBaseData(): CancelablePromise<baseDataResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/baseData',
      errors: {
        400: `Bad input parameter`,
        401: `Unauthorized`,
        403: `Api gateway error`,
        500: `Internal Server Error`,
        503: `Service Unavailable`,
      },
    });
  }
}
